import { cn } from '@/lib/utils';

import { TextInput, type TextInputProps } from '../TextInput';

const InputGroupTextInput = ({ ref, className, ...props }: TextInputProps) => {
  return (
    <TextInput
      ref={ref}
      data-slot="input-group-control"
      className={cn(
        'min-w-0 flex-1 rounded-none border-0 bg-transparent py-0 shadow-none ring-0 focus:border-transparent focus:ring-0 disabled:bg-transparent',
        'focus:shadow-none data-invalid:border-0 data-warning:border-0',
        className,
      )}
      {...props}
    />
  );
};

InputGroupTextInput.displayName = 'InputGroupTextInput';

export default InputGroupTextInput;
